import { Arg, Metadata } from '../../../../utils/spds/metadata';
import FlexRow from '../../layout/flex/row.gjs';
import Super from '../../core/base.gjs';

const METADATA = Metadata.define({
  description: 'Body text content for the empty state component',
  meta: {
    body: Arg.string({ description: 'Body text content' }).required(),
  },
  name: 'Empty State Body',
});

export default class SpdsFeedbackEmptyStateBody extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-feedback-empty-state-body';

  <template>
    <FlexRow
      @content={{@body}}
      class={{this.classes}}
      data-test-spds-feedback-empty-state-body
      {{this.validateArguments}}
      ...attributes
    />
  </template>
}

export const EMPTY_STATE_BODY_METADATA = SpdsFeedbackEmptyStateBody.metadata;
